function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.25 3.75a3 3 0 003 3M3 15l.465-2.325c.106-.53.159-.795.256-1.042.086-.219.197-.427.332-.62.152-.218.343-.409.725-.79L12 3c.409-.41.614-.614.834-.723a1.5 1.5 0 011.332 0c.22.11.425.314.834.723s.613.613.723.834a1.5 1.5 0 010 1.332c-.11.22-.314.425-.723.834l-7.222 7.222c-.382.382-.573.573-.79.725a3.001 3.001 0 01-.622.332c-.247.097-.511.15-1.041.256L3 15z",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgEditNew = function SvgEditNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    stroke: "currentColor",
    fill: "none"
  }, props), _ref);
};

export default SvgEditNew;